export default [
  {
    label: 'Jr',
    value: 'Jr',
  },
  {
    label: 'Sr',
    value: 'Sr',
  },
  {
    label: 'I',
    value: 'I',
  },
  {
    label: 'II',
    value: 'II',
  },
  {
    label: 'III',
    value: 'III',
  },
];
